import React, { useState } from 'react';
import { Table, Button, Input, Select, Popconfirm, Space, Card } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { getSearchApi } from '../../../network/itemList';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchPatients } from '../../../network/appointment';
const UomList = ({ setDataSourceUom, dataSourceUom, t, form }) => {
  // const { data: stockUoms } = useQuery({
  //   queryKey: [queryKeys.getstockUomsUom],
  //   queryFn: () => getSearchApi('UOM'),
  //   keepPreviousData: true,
  // });
  const [searchTextUOM, setSearchTextUOM] = useState('');
  const { data: stockUoms } = useQuery({
    queryKey: [queryKeys.getSearchuom, searchTextUOM],
    queryFn: () => getSearchPatients('UOM', searchTextUOM),
    keepPreviousData: true,
    enabled: searchTextUOM?.length >= 3 || searchTextUOM?.length === 0,
  });
  const [count, setCount] = useState(0);
  const columns = [
    {
      title: t.uom,
      dataIndex: 'uom',
      render: (text, record, index) => (
        <Select
          showSearch
          // placeholder={t.uom}
          placeholder={t.uom}
          style={{ width: '300px' }}
          optionFilterProp="children"
          filterOption={false}
          popupMatchSelectWidth={false}
          onSearch={(value) => {
            setSearchTextUOM(value);
          }}
          value={record.uom}
          options={stockUoms?.message?.map((user) => ({
            value: user.value,
            label: user.value,
          }))}
          onChange={(value) => {
            const newDataSource = [...dataSourceUom];
            newDataSource[index] = {
              ...newDataSource[index],
              uom: value,
            };
            setDataSourceUom(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.conversionFactor,
      dataIndex: 'conversion_factor',
      render: (text, record, index) => (
        <Input
          placeholder={t.conversionFactor}
          style={{ width: '300px' }}
          value={record.conversion_factor}
          type="number"
          min={0}
          onChange={(e) => {
            const newDataSource = [...dataSourceUom];
            newDataSource[index] = {
              ...newDataSource[index],
              conversion_factor: e.target.value,
            };
            setDataSourceUom(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
      uom: '',
      conversion_factor: '',
    };
    setDataSourceUom((prevDataSource) => [...prevDataSource, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceUom.filter((item) => item.key !== key);
    setDataSourceUom(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceUom}
        columns={columns}
        pagination={{
          hideOnSinglePage: true,
        }}
        scroll={{ x: 'max-content' }}
        // className="table"
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default UomList;
